<template>
  <div>
    <div class="wrapper">
      <h2 class="title">
        <em class="far fa-life-ring"></em>
      </h2>
      <h4 class="text-center">Want to pass on your feedback, thoughts or concerns?</h4>

      <div class="petition-form wwf-form light" :class="{ 'hide' : step2 }">
        <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
          <div class="petition-form">
            <input
              name="emailAddress"
              type="email"
              v-model="emailAddress"
              v-validate="'required|email'"
              :class="{'border-red': errors.has('emailAddress')}"
              placeholder="Email Address"
            />
            <input
              name="subject"
              type="text"
              v-model="subject"
              v-validate="'required'"
              :class="{'border-red': errors.has('subject')}"
              placeholder="Subject"
            />
            <input
              name="phone"
              type="text"
              v-model="phone"
              v-validate="'required'"
              :class="{'border-red': errors.has('phone')}"
              placeholder="Phone"
            />
            <textarea
              name="message"
              type="text"
              v-model="message"
              v-validate="'required'"
              :class="{'border-red': errors.has('message')}"
              placeholder="Message"
              class
            ></textarea>

            <input type="button" v-on:click="postTicket" value="Submit" />
          </div>
        </div>
      </div>

      <div :class="{ 'hide' : step1 || (step2 && serverErrors) }">
        <p>Your message has been received by our team and we will respond as soon as possible.</p>
      </div>

      <div :class="{ 'hide' : step1 || (step2 && !serverErrors) }">
        We are sorry, an error has occurred and your request could not be submitted. Alternatively, you can contact us by email at enquiries@wwf.org.au
        <p
          class="text-center hide-for-large"
        >Please tap on the orange question mark on the bottom-right of your screen</p>
      </div>

      <p class="text-center show-for-large">
        WWF-Australia takes all complaints and feedback seriously. For information about our Complaint Handling Process, please
        <a
          href="/ArticleDocuments/391/doc-policy-wwfaus-complaint-handling-jul18.pdf.aspx"
          target="_blank"
          class="document pdf"
        >
          click here
          <span class="file-info">
            &nbsp;(
            <span class="file-type">PDF</span>&nbsp;
            <span class="file-size">380.6KB</span>)
          </span>
        </a>.
      </p>
      <p
        class="text-center hide-for-large"
      >Please tap on the orange question mark on the bottom-right of your screen</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactUs",
  data() {
    return {
      isShake: false,
      step1: true,
      step2: false,
      serverErrors: false,
      emailAddress: "",
      subject: "",
      phone: "",
      message: "",
      isLoading: false,
    };
  },
  methods: {
    postTicket: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.isLoading) {
            this.isLoading = true;
            this.$http
              .post(wwfconfigs.WEB_API + "/zendesk/create", {
                emailAddress: this.emailAddress,
                subject: this.subject,
                phone: this.phone,
                message: this.message,
              })
              .then((response) => {
                this.step1 = false;
                this.step2 = true;
                this.isLoading = false;
                console.log(response);
              })
              .catch((err) => {
                this.step1 = false;
                this.step2 = true;
                this.serverErrors = true;
                this.isLoading = false;
                console.error(err);
              });
          }
        } else {
          console.log("form invalid");
          this.isShake = true;
          setTimeout(
            function () {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  padding: 35px;
  border-radius: 5px;
  border: 1px solid var(--wwfTransparentBlack010);
}

.wrapper .title {
  margin: 0px 0px 10px;
  color: var(--wwfOrange);
  font-weight: 400;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// ContactUs.vue?23e1d9c8